import { OrganizationalUnitEditionComponent } from './OrganizationalUnit.edition.component';
import { IFilterDTO, OrganizationalUnitDTO } from '../../api/plyca-dtos';
import { UserService } from '../../user.service';
import { BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import { Component, OnInit, Optional, ElementRef, AfterContentInit, OnDestroy, ViewChild, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin, Observable, of } from 'rxjs';
import { FormConfig } from '../../components/forms/form.objects';
import { UserDTO } from '../../api/plyca-dtos';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { FilteredBaseFormComponent, TModel } from '../../tasks/baseFormComponent/filteredBaseForm.component';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { PropertyService } from '../../properties/property.service';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { TreeNode } from 'primeng-lts/api';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { PaginationDTO } from '../../api/PaginationModel';



@Component({
  selector: 'orgunitpanel-form',
  templateUrl: 'OrganizationalUnitPanel.template.html',
  providers: [DialogService]
})
export class OrganizationalUnitPanelComponent
  extends FilteredBaseFormComponent<OrganizationalUnitDTO>
  implements OnInit, AfterContentInit, OnDestroy {


  private properties = {};
  @ViewChild('actionsTemplate')
  fromTemplate: TemplateRef<any>;
  groupedInfo: any;
  allElements: any;
  filterText: string;
  loading: boolean;
  root = true;
  /*
  pageInfo: PaginationInfo;
  public orgPageInfo = {};*/



  // ** Definición de variables parámetros funcionales

  // ** this.model.ui.onNodeExpand ************************
  // true: Define si se ha abierto una rama de un árbol para incluir los hijos en el árbol.
  //        Si esa rama ya estaba activa no se piden a servidor los hijos
  // false: Si la consulta al servidor es del árbol completo


  // ** this.root = true (root) ************************
  // t** his.unitParent (organismoPadre) ************************

  /* ** Consulta de hijos ************************
    if (!StringUtils.isNotBlank(organismoId)
    &&
    !StringUtils.isNotBlank(organismoNombre)
    &&
    (StringUtils.isNotBlank(organismoPadre) || root)
        ){
    query+= " ,(SELECT count(1) FROM organismo  org WHERE org.ORGANISMOPADRE = organismo.ORGANISMOHEX) AS HIJOS   ";

  }
   */

  /* ** Consulta del nodo raiz 0 o cualquier otro nodo raiz ************************
  } else if (StringUtils.isNotBlank(organismoPadre)) {
    query+= " AND ORGANISMO.ORGANISMOPADRE LIKE '%"+organismoPadre+"%' ";
  } else if (root) {
    query+= " AND ORGANISMO.ORGANISMOPADRE IS NULL ";
  }
  */

  getObjectIdentifier() {
    throw new Error('Method not implemented.');
  }

  constructor(
    elem: ElementRef,
    public translationService: TranslateService,
    private userService: UserService,
    private plycaErrorHandler: PlycaErrorHandler,
    private propertyService: PropertyService,
    public helpService: HelpService,
    @Optional() protected activatedRoute: ActivatedRoute

  ) {
    super(elem);
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.ORGS));
    // this.initPageValues();
  }
  ngOnInit(): void {


    this.subscribe(

      forkJoin([

        this.propertyService.getProperty('PUBLICAR_ORGANISMO_EN_PORTAL', '')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))
        ,
        this.propertyService.getProperty('MNTO_USUARIOS', 'false')
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))

      ]).pipe(
        map(

          (prop: any[]) => {


            this.properties['PUBLICAR_ORGANISMO_EN_PORTAL'] = prop[0] === 'SI';
            this.properties['MNTO_USUARIOS'] = prop[1] === 'true';


          }),
        finalize(() => {
          this.autosearch = false;

          super.ngOnInit();
        })
      )

    )


  }
  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  ngAfterContentInit(): void {

  }

  getFormSettingURL(): string {
    return 'admin/orgUnitsFilterISettings.json';
  }
  getServiceURL(operation?: string): string {
    if (operation === 'insert') {
      return this.configuration.ADMIN_USER_SERVICE_URL;
    } else {
      return this.configuration.ORGANIZATIONUNIT_SERVICE_URL;
    }

  }
  getTitle(model: UserDTO): string {
    return 'ControlPanel.orgunit.edit';
  }
  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'ControlPanel.organizationalunits.title';
    headerInfo.titleIcon = 'fas fa-sitemap';
    return headerInfo;
  }

  reset() {
    this.clearFilter();
    // this.initModel();
    this.model.filter['organizationalUnit'] = this.userService.sessionInfo.user.organizationalUnit?.entity ?
      this.userService.sessionInfo.user.organizationalUnit
      : this.userService.sessionInfo.user.organizationalUnit?.entityDTO;
    this.root = true;
    this.onChangeFilter(this.model, this.model.filter['organizationalUnit']);

  }
  initHeaderActions() {

    this.subscribe(
      this.headerActionsService.addAction(
        'General.reset.filters',
        'fas fa-undo',
        'btn-secondary',
        true
      ), success => {
        this.reset();


      });
    /*

        this.subscribe(this.headerActionsService
          .addAction(
            'General.search.text',
            'fas fa-search',
            'btn-primary',
            true
          ), () => {

            this.root = true;
            this.search();


          });

          */
    this.subscribe(this.headerActionsService
      .addAction(
        'General.add',
        'fas fa-plus',
        'btn-primary',
        true
      ), () => {
        this.insertOrg();
        /*  this.uiService.showSuccess(
            'Operación no implementada',
            this.translate.instant('General.info'),
            'warn'
          );*/


      });


    this.headerActionsService.addDivider();
    this.addBackAction();
  }


  initModel(): TModel<OrganizationalUnitDTO> {
    this.model = {} as TModel<OrganizationalUnitDTO>;
    this.model.ui = {};
    this.model.ui.mensaje = '';
    this.model.ui.showResults = false;
    this.model.ui.root =
      this.userService.sessionInfo.user.organizationalUnit?.entity ?
        this.userService.sessionInfo.user.organizationalUnit.identifier
        : this.userService.sessionInfo.user.organizationalUnit?.entityDTO.identifier;

    this.model.filter = {};
    this.model.filter['organizationalUnit'] = this.userService.sessionInfo.user.organizationalUnit?.entity ?
      this.userService.sessionInfo.user.organizationalUnit
      : this.userService.sessionInfo.user.organizationalUnit?.entityDTO;
    /* this.model.filter['organizationalUnit'] = {};
     this.model.filter['organizationalUnit']['identifier'] = '0000';*/
    this.model.ui.properties = this.properties;
    this.reset();
    return this.model;
  }
  updateTableModel(result: PaginationDTO<OrganizationalUnitDTO>): TModel<OrganizationalUnitDTO> {
    if (result?.content) {
      let content: OrganizationalUnitDTO[] = result.content;
      this.model.tableModel = content;
      /*this.translationService.instant('Tasks.showing')
      + ' ' + content.length + ' ' + this.translationService.instant('ControlPanel.organizationalunits.title');*/

      this.model.ui.showResults = true;
      if (this.model.ui.onNodeExpand === true) {
        this.allElements = this.allElements.concat(content);
      } else {
        this.allElements = content;
        // La primera vez se incluye el organismo del usuario y el resultado de la consulta
        // Para construir el nivel nivel
        this.allElements = [this.model.filter['organizationalUnit']].concat(this.allElements);



      }
      this.model.ui.mensaje = this.translationService.instant('General.total') + ' ' + this?.allElements?.length;

      // guardar paginación
      /*
      [{
      pageInfo: PaginationInfo,
      orgHex: string
    }];*/
      /*
          let pageInfo = new PaginationInfo();
          pageInfo.number = result.page.number;
          pageInfo.size = result.page.size;
          pageInfo.totalElements = result.page.totalElements;
          pageInfo.totalPages = result.page.totalPages;


          this.orgPageInfo[this.model.ui.root] = pageInfo;

      */

      // this.groupInfo(content);
      //  this.expandRootNode();
    }

    // Se reagrupa aunque no haya resultados
    // Si se pone un filtro sin resultados se muestra el nodo seleccionad sin hijos
    this.groupInfo(this.allElements);

    return this.model;
  }

  dtoToModel(dto: OrganizationalUnitDTO): Observable<TModel<OrganizationalUnitDTO>> {
    throw new Error('Method not implemented.');
  }
  modelToDTO(model: TModel<OrganizationalUnitDTO>): OrganizationalUnitDTO {
    throw new Error('Method not implemented.');
  }
  filterToParam(): IFilterDTO {


    let params = [];
    if (this.model.filter['organizationalUnit'] && this.model.filter['organizationalUnit'].identifier) {
      delete params['organismoHex'];

      params['organismoHex'] = this.model.filter['organizationalUnit'].identifier;

    } else {
      delete params['organismoHex'];
    }



    if (this.model.filter['hasSignature'] === undefined) {
      delete params['hasSignature'];
    } else {
      params['hasSignature'] = this.model.filter['hasSignature'];
    }

    if (this.model.filter['person'] && this.model.filter['person'].identifier) {

      params['personId'] = this.model.filter['person'].identifier;

    } else {
      delete params['personId'];
    }

    if (this.model.filter['user'] && this.model.filter['user'].identifier) {

      params['identifier'] = this.model.filter['user'].identifier;

    } else {
      delete params['identifier'];
    }

    // params['expand'] = 'expansionSet:manage';

    params['expand'] = 'expansionSet:collection';


    if (this.root) {
      this.root = false;
      params['unitParent'] = this.model.ui.root;
      //  params['root'] = true;
      // params['organismoHex'] = this.userService?.sessionInfo?.user?.organizationalUnit?.identifier;
      /*if (this?.userService?.sessionInfo?.user?.organizationalUnit?.unitParent?.identifier) {
        params['unitParent'] = this.model.ui.root;
      }*/

    } else {
      params['unitParent'] = this.model.ui.root;
    }
    // OJO: no quitar este parámetro para que no traiga todo el árbol
    // Hace que solo se consulte el nivel del nodo selecionado
    params['root'] = true;
    /*
        params['size'] = this.pageInfo.size;
        params['page'] = this.pageInfo.number;
    */
    return params;
  }

  public preEditRowFunction(model: any) {
    let params: any = {};
    params.retrievAllProfilesApplicationData = true;



    if (model._parent.ui?.allProfiles) {
      if (model.profiles && model.profiles.length > 0) {
        model.profiles.map((element) => {
          // ip.profile.description = profile.description + ' - ' + profile.application;
          element.uuid = element.identifier;
          element.identifier = element.identifier + '<>' + element.application;
        });

      }

      if (model.queries && model.queries.length > 0) {
        model.queries.map((element) => {
          // ip.profile.description = profile.description + ' - ' + profile.application;
          element.uuid = element.identifier;
          element.identifier = element.identifier + '<>' + element.application;
        });

      }
      return of(model);
    } else {


      return forkJoin([

        this.plycaService.query<any>(
          this.configuration.PROFILES_SERVICE_URL + '', params)
          .pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          })),

        this.plycaService
          .getResultSearchSetting(this.configuration.URL_BASE + this.configuration.UserApiUrl + this.configuration.ApiVersion + 'searchsettings/TIPO_QUERY' + '/values',
            undefined
          ).pipe(catchError((error: any) => {
            console.log(error)
            return of(undefined)
          }))


      ]).pipe(
        map(

          ([resultProfiles, resultQueries]) => {
            if (resultProfiles) {
              model._parent.ui.allProfiles = {};
              if (resultProfiles && resultProfiles.content) {
                model._parent.ui.allProfiles = resultProfiles.content;
                model._parent.ui.allProfiles.map((profile) => {
                  profile.description = profile.description + ' - ' + profile.application;
                  profile.identifier = profile.identifier + '<>' + profile.application;
                })

              } else {
                model._parent.ui.allProfiles = [];

              }


            }
            if (resultQueries?.content) {
              model._parent.ui.allQueries = {};
              if (resultQueries && resultQueries.content) {
                model._parent.ui.allQueries = resultQueries.content;
                model._parent.ui.allQueries.map((element) => {
                  // element = element.singleValue;
                  element.identifier = element.singleValue.identifier;
                  element.description = element.singleValue.description;
                  delete element['columns'];
                  delete element['singleValue'];
                })

              } else {
                model._parent.ui.allQueries = [];

              }
            }
            if (model.profiles && model.profiles.length > 0) {
              model.profiles.map((element) => {
                // ip.profile.description = profile.description + ' - ' + profile.application;
                element.uuid = element.identifier;
                element.identifier = element.identifier + '<>' + element.application;
              });

            }

            if (model.queries && model.queries.length > 0) {
              model.queries.map((element) => {
                // ip.profile.description = profile.description + ' - ' + profile.application;
                element.uuid = element.identifier;
                element.identifier = element.identifier + '<>' + element.application;
              });

            }
            return model;
          }),
        finalize(() => {

        })
      )










    }

  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.showValidations = true;
    formConfig.isModalWindow = false;


    formConfig.functions.push({
      identifier: 'onChangeFilter',
      fn: this.onChangeFilter.bind(this)
    });


    return of(formConfig);
  }



  public cancel(model: any) {
    this.uiService.showSuccess(
      this.translate.instant('General.msg.cancel'),
      this.translate.instant('General.info'),
      'warn'
    );

  }

  public deleteOrg(model: any) {
    this.confirmationService.confirm({
      message: this.translationService.instant('General.confirm.action.delete'),
      accept: () => {
        this.uiService.showSuccess(
          'Operación no implementada',
          this.translate.instant('General.info'),
          'warn'
        );

      }
    });
  }
  show(model: any) {
    this.modalOpen(model, 'show');
  }
  copy(model: any) {
    this.modalOpen(model, 'copy');
  }
  edit(model: any) {
    let operation = model.identifier ? 'update' : 'insert';
    this.modalOpen(model, operation);
  }
  modalOpen(model: any, operation: string) {
    let css = 'formEdition';
    let title = 'ControlPanel.organizationalunits.actions.edit';
    if (operation === 'insert' || operation === 'copy') {
      title = 'ControlPanel.organizationalunits.actions.new';
    }
    if (operation === 'show') {
      title = 'ControlPanel.organizationalunits.actions.show';
      css = 'viewStyle';
    }

    let config: DynamicDialogConfig = {
      header: this.translate.instant(title),
      width: '90%',
      styleClass: css

    };

    config['id'] = model.identifier;
    config['operation'] = operation;
    // config['readonly'] = readonly
    this.waitService.startWaiting();
    const dialog = this.dialogService.open(OrganizationalUnitEditionComponent, config);
    dialog.onClose.subscribe(reload => {
      if (reload) {
        this.onChangeFilter(this.model, this.model.filter['organizationalUnit']);
      }



    });

  }


  insertOrg() {
    let css = 'formEdition';
    let title = 'ControlPanel.organizationalunits.actions.new';



    let config: DynamicDialogConfig = {
      header: this.translate.instant(title),
      width: '90%',
      styleClass: css

    };

    // config['id'] = undefined;
    config['operation'] = 'insert';
    config['id'] = 'new';
    this.waitService.startWaiting();
    const dialog = this.dialogService.open(OrganizationalUnitEditionComponent, config);
    dialog.onClose.subscribe(reload => {
      this.onChangeFilter(this.model, this.model.filter['organizationalUnit']);


    });

  }

  modalError(error) {
    // this.ref.close();
    this.plycaErrorHandler.showServerError(error);
    // this.uiService.showMessage(
    //   error.errors[0].message,
    //   this.translateService.instant('General.error'),
    //   'errorStyle'
    // );
  }


  groupInfo(elements: any[]) {

    this.groupedInfo = elements

    /*.sort(
    (e1, e2): any => {


      if (!e1.identifier && !e2.identifier) {
        // son iguales
        return 0;
      } else if (!e1.identifier) {
        // doc1 va despues de doc2
        return -1;
      } else if (!e2.identifier) {
        // doc1 va antes que doc2
        return 1;
      } else if (e1.identifier < e2.identifier) {
        return -1;
      } else if (e1.identifier > e2.identifier) {
        return 1;
      } else {
        return 0;
      }
    });*/
    this.groupedInfo = this.toNodeArray(elements);
    // this.allGroupedInfo = this.groupedInfo;

  }

  toNodeArray(elements: any[]): Array<TreeNode> {
    let nodes: Array<TreeNode> = [];
    if (elements) {


      let element = elements[0];
      let childrens = this.getChildrens(element.identifier, elements);
      let expandedIcon = 'pi-file';
      let collapsedIcon = 'pi-file';

      if (childrens && childrens.length > 0) {
        expandedIcon = 'pi pi-folder-open';
        collapsedIcon = 'pi pi-folder';
        element['root'] = true;
      } else {
        element['root'] = false;
      }

      let grupo = {

        label: element.identifier + '-' + element.name,
        expandedIcon: expandedIcon,
        collapsedIcon: collapsedIcon,
        data: element,
        leaf: !element.childrens,
        expanded: childrens && childrens.length > 0,

        children: childrens ? childrens : []
      };

      nodes.push(grupo);


    }
    return nodes;
  }
  getChildrens(identifier: any, elements: any[]): Array<TreeNode> {
    return elements.filter(org => org?.unitParent?.identifier === identifier)
      .map(org => this.toNode(org, elements));
  }

  toNode(element: any, elements): TreeNode {
    let node: TreeNode;
    if (element) {
      let childrens = this.getChildrens(element.identifier, elements);
      let expandedIcon = 'pi-file';
      let collapsedIcon = 'pi-file';
      if (childrens && childrens.length > 0) {
        expandedIcon = 'pi pi-folder-open';
        collapsedIcon = 'pi pi-folder';
        element['root'] = true;
      } else {
        element['root'] = false;
      }
      node = {
        label: element.identifier + '-' + element.name,
        expandedIcon: expandedIcon,
        collapsedIcon: collapsedIcon,
        data: element,
        leaf: !element.childrens,
        expanded: childrens && childrens.length > 0,
        // expanded: false,
        children: childrens ? childrens : []
      };
    }
    return node;
  }

  /*
  public updateFilter() {
    // Agrupa
    let _searchText: string = this.filterText;
    let filtered = [];
    if (!_searchText) {
      _searchText = '';
      filtered = this.allElements;
    } else {
      filtered = this.allElements.filter(
        (element) =>
          element.name.toLowerCase().indexOf(_searchText.toLowerCase()) !== -1
          || element.identifier.toLowerCase().indexOf(_searchText.toLowerCase()) !== -1

      )
    }

    this.groupInfo(filtered);
    /*
        this.model.ui.mensaje = this.translationService.instant('Tasks.showing')
          + ' ' + this.allElements.length + ' '
          + this.translationService.instant('ControlPanel.organizationalunits.title')
          + ' ' + filtered.length;*/
  //}










  onNodeExpand(event) {
    if (!event.node.children || event.node.children.length === 0) {


      this.loading = true;
      this.model.ui.root = event.node.data.identifier;
      this.model.ui.onNodeExpand = true;
      this.waitService.startWaiting();

      this.subscribe(this.searchOb()
        .pipe(
          finalize(() => {
            this.loading = false;
            this.waitService.cancelWaiting();
            this.model.ui.onNodeExpand = false;
          })));

    }

  }

  onActionExecute(model: any, searchResult: any) {
    this.onChangeFilter(this.model, this.model.filter['organizationalUnit']);

  }


  onChangeFilter(model: any, searchResult: any) {

    // Buscamos solo si se ha selccionado un elemento en el filtro
    if (searchResult) {

      this.model.filter['organizationalUnit'] = searchResult;

      // Se establece el nodo padre de la consulta para que traiga hijos
      this.model.ui.root = searchResult.identifier;
      // Tomamos como raiz el org padre no el nodo 0
      this.root = false;
      // Solo en el caso del nodo raiz root = true , si no servidor no  devuleve los hijos
      if (searchResult.identifier === '0000') {
        this.root = true;
      }
      // Consulta árbol completo, no solo los hijos que se expanden
      this.model.ui.onNodeExpand = false;
      // Se borra la lista actual y se deja solo el nodo seleccionado
      this.allElements = [searchResult];

      // Se buscan los hijos del nodo seleccionado en el filtro
      this.loading = true;
      this.subscribe(this.searchOb()
        .pipe(
          tap(() => {
            this.loading = false;
            this.waitService.cancelWaiting();
            return searchResult;
          }),
          catchError(
            (error: any) => {
              this.plycaErrorHandler.showServerError(error);
              return of(true);
            })

        ));
    } else {
      return searchResult;
    }

  }


  /*
  initPageValues(): void {
    this.pageInfo = new PaginationInfo();
    this.pageInfo.size = 5;
    this.pageInfo.number = 0;
  }*/
}
